import { useEffect, useState } from 'react';
import styles from './style.module.css';
import { Card } from '../../components/Card';
import defaultCover from '../../assets/images/avatar.png';
import defaultCoverThanks from '../../assets/images/coverThanks.png';
import iconTrofy from '../../assets/images/trofy.png';
import { Button } from '../../components/Button';
import { ModalCallbackAlert } from '../../components/ModalCallbackAlert';
import { Link } from 'react-router-dom';

export function ThanksPage() {
  const [photoURL, setPhotoUrl] = useState('');
  const [name, setName] = useState('');
  const [clientName, setClientName] = useState('');
  const [clientUrl, setClientUrl] = useState('');
  const [actionId, setActionId] = useState('');
  const [clientId, setClientId] = useState('');
  const [playerId, setPlayerId] = useState('');
  const [hostId, setHostId] = useState('');
  const [logoURL, setLogoURL] = useState('');
  const [modalCallbackIsOpen, setModalCallbackIsOpen] =
    useState<boolean>(false);

  useEffect(() => {
    const playerPhoto = sessionStorage.getItem('playerPhoto');
    const playerName = sessionStorage.getItem('playerName');
    const clientName = sessionStorage.getItem('clientName');
    const clientUrl = sessionStorage.getItem('clientUrl');
    const actionId = sessionStorage.getItem('actionId');
    const clientId = sessionStorage.getItem('clientId');
    const playerId = sessionStorage.getItem('playerId');
    const hostId = sessionStorage.getItem('hostId');
    const logoURL = sessionStorage.getItem('clientLogo');

    if (playerPhoto) {
      setPhotoUrl(playerPhoto);
    } else {
      setPhotoUrl(defaultCover);
    }

    if (playerName) {
      setName(playerName);
    } else {
      setName('Player');
    }

    if (clientUrl) {
      setClientUrl(clientUrl);
    }

    if (actionId) {
      setActionId(actionId);
    }

    if (clientId) {
      setClientId(clientId);
    }

    if (playerId) {
      setPlayerId(playerId);
    }

    if (hostId) {
      setHostId(hostId);
    }

    if (logoURL) {
      setLogoURL(logoURL);
    }

    if (clientName) {
      setClientName(clientName);
    }
  }, []);

  const toggleModalCallbackAlert = () => {
    setModalCallbackIsOpen(!modalCallbackIsOpen);
  };

  return (
    <>
      {clientUrl && clientUrl !== 'emr' && (
        <ModalCallbackAlert
          title="Não deixe passar!"
          text={`Você também pode ganhar prêmios como ${name}!`}
          modalIsOpen={modalCallbackIsOpen}
          toggleModal={toggleModalCallbackAlert}
        />
      )}
      <div className="container">
        <div className="container">
          <div className="mt-4">
            <div className="d-flex align-items-center flex-column">
              <div className={styles.coverWrapperProfile}>
                <div className={styles.coverProfile}>
                  <img src={photoURL} alt="Foto de perfil" />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-3">
            <h2 className="text-center">Obrigado(a)</h2>
            <p className="text-center">
              Em breve um de nossos consultores
              <br />
              entrará em contato!
            </p>
          </div>
          <div className="container">
            <hr className="my-3" />
            <div className="d-flex justify-content-center">
              <div className="my-4">
                <img src={logoURL} alt="" width={150} />
              </div>
            </div>
            <Card>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <p className="fs-2">
                    Quer ganhar prêmios?{' '}
                    <img src={iconTrofy} width={35} alt="" />
                  </p>
                  <p>
                    Faça como {name}: Indique a {clientName} !
                  </p>

                  <div className="my-3">
                    <Link
                      to={`/register?action=${actionId}&client=${clientId}${
                        hostId && hostId !== 'undefined'
                          ? `&player=${hostId}`
                          : playerId
                      }`}
                    >
                      <Button
                        icon="east"
                        text="Quero participar"
                        color="primary"
                      />
                    </Link>
                    {/* <a
                      href={`${location.protocol}//${
                        location.host
                      }/register?action=${actionId}&client=${clientId}${
                        hostId && hostId !== 'undefined'
                          ? `&player=${hostId}`
                          : playerId
                      }`}
                    >
                      
                    </a> */}
                  </div>
                </div>
                <div className="col-sm-12 col-md-6">
                  <div className="text-end">
                    <img
                      className="img-fluid"
                      src={defaultCoverThanks}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
